/**
 * Temporary utility functions to replace @pebula/nform functionality
 * These are stub implementations to allow the build to proceed
 * TODO: Replace with proper Angular Reactive Forms implementation
 */

import { ValidatorFn, Validators as AngularValidators } from '@angular/forms';

/**
 * Wraps Angular validators to be compatible with @pebula/nform
 * This is a temporary workaround until migration away from nform is complete
 */
export class SgValidators {
  static required: ValidatorFn = AngularValidators.required as any;
  static email: ValidatorFn = AngularValidators.email as any;

  static min(min: number): ValidatorFn {
    return AngularValidators.min(min) as any;
  }

  static max(max: number): ValidatorFn {
    return AngularValidators.max(max) as any;
  }

  static maxLength(maxLength: number): ValidatorFn {
    return AngularValidators.maxLength(maxLength) as any;
  }

  static minLength(minLength: number): ValidatorFn {
    return AngularValidators.minLength(minLength) as any;
  }

  static pattern(pattern: string | RegExp): ValidatorFn {
    return AngularValidators.pattern(pattern) as any;
  }

  static compose(validators: ValidatorFn[]): ValidatorFn {
    return AngularValidators.compose(validators) as any;
  }
}

export function setSelectOptions<T>(
  event: any,
  key: string,
  source: T[],
  mapper: (item: T) => { value: any; label?: string }
): void;
export function setSelectOptions<T>(
  record: any,
  source: T[],
  mapper: (item: T) => { value: any; label?: string }
): void;
export function setSelectOptions<T>(...args: any[]): void {
  let record: any;
  let sourceArray: any[];
  let mapper: (item: any) => undefined | { value: any; label?: string };

  if (args.length === 4) {
    // First overload: setSelectOptions(event, key, source, mapper)
    const [event, key, source, mapperFn] = args;
    record = event?.records?.[key];
    sourceArray = source;
    mapper = mapperFn;
  } else if (args.length === 3) {
    // Second overload: setSelectOptions(record, source, mapper)
    [record, sourceArray, mapper] = args;
  }

  if (!record) {
    return;
  }

  const data: any = record.data || {};
  const options: { value: any; label?: string }[] = (data.options = []);

  for (const item of sourceArray) {
    const mapped = mapper(item);
    if (mapped) {
      options.push(mapped);
    }
  }

  if (record.mergeData) {
    record.mergeData(data);
  }
}

export function emptyAsUndefined(value: any): any {
  return value === '' ? undefined : value;
}
